import { render, staticRenderFns } from "./CarrierDestinationPriceList.vue?vue&type=template&id=70d2dc0e&scoped=true&"
import script from "./CarrierDestinationPriceList.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2dc0e",
  null
  
)

export default component.exports